import React from 'react';

/**
 * Skeleton loading screen that matches Home page layout
 * Shows immediately while Home component is being lazy-loaded
 */
const HomeSkeleton = () => {
  return (
    <div className="min-h-screen bg-[#F8FAFC] animate-pulse">
      {/* Header area */}
      <div className="bg-white border-b border-[#E2E8F0] px-4 py-4">
        <div className="max-w-7xl mx-auto">
          {/* Search bar skeleton */}
          <div className="h-12 bg-[#E2E8F0] rounded-xl w-full max-w-2xl mx-auto" />
        </div>
      </div>

      {/* Main content */}
      <div className="max-w-7xl mx-auto px-4 py-6">
        {/* Filter buttons skeleton */}
        <div className="flex gap-2 mb-6 overflow-x-auto">
          {[1, 2, 3, 4, 5].map((i) => (
            <div key={i} className="h-10 w-24 bg-[#E2E8F0] rounded-full flex-shrink-0" />
          ))}
        </div>

        {/* Job cards skeleton */}
        <div className="space-y-4">
          {[1, 2, 3, 4, 5].map((i) => (
            <div key={i} className="bg-white rounded-2xl p-4 border border-[#E2E8F0]">
              <div className="flex items-start gap-4">
                {/* Company logo skeleton */}
                <div className="w-16 h-16 bg-[#E2E8F0] rounded-xl flex-shrink-0" />

                <div className="flex-1 space-y-3">
                  {/* Job title skeleton */}
                  <div className="h-6 bg-[#E2E8F0] rounded w-3/4" />

                  {/* Company name skeleton */}
                  <div className="h-4 bg-[#E2E8F0] rounded w-1/2" />

                  {/* Tags skeleton */}
                  <div className="flex gap-2">
                    <div className="h-6 w-20 bg-[#E2E8F0] rounded-full" />
                    <div className="h-6 w-24 bg-[#E2E8F0] rounded-full" />
                    <div className="h-6 w-16 bg-[#E2E8F0] rounded-full" />
                  </div>
                </div>

                {/* Salary skeleton */}
                <div className="hidden md:block">
                  <div className="h-8 w-32 bg-[#E2E8F0] rounded-lg" />
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default HomeSkeleton;
